/** Fotos de la página del plan online (/plan-online). LISTA VACÍA = la sección de fotos NO se
 *  renderiza (ni deja ningún texto en el HTML).
 *
 *  Para activarla, sumar objetos a `FOTOS_PLAN_ONLINE` (este es el único lugar):
 *    { src: "/plan-online/foto-1.webp", alt: "Descripción concreta de lo que se ve", pie: "Texto opcional" }
 *  Los archivos van en `public/plan-online/` (o una URL de Storage). Requisitos antes de sumar una:
 *   - Autorización por escrito de cada persona que aparece (y de su apoderado si fuera menor; no
 *     usar fotos de menores en este plan, es para mayores de 16 años). Anotar dónde está el permiso.
 *   - `alt` describe la imagen (no «foto 1»); `pie` es opcional y nunca debe prometer resultados.
 *   - Sin testimonios ni cifras de resultados dentro de la imagen o del pie.
 *  `width` y `height` (opcionales) son las dimensiones reales del archivo: evitan saltos de diseño. */
export type FotoPlanOnline = {
  src: string;
  alt: string;
  pie?: string;
  width?: number;
  height?: number;
};

/** Autorización: mensaje de WhatsApp del 2026-11-01 (guardado por el dueño), tras ver la foto y el uso público en el sitio. */
export const FOTOS_PLAN_ONLINE: FotoPlanOnline[] = [
  { src: "/plan-online/paralelas.webp", alt: "Estudiante del plan online entrenando con paralelas bajas al aire libre, con las manos apoyadas en la barra", width: 1050, height: 1400 },
  // Autorización de la persona que aparece: WhatsApp del 2026-11-01 («Dale nomás con la foto de tuck»).
  { src: "/plan-online/tuck.webp", alt: "Estudiante del plan online practicando un tuck invertido en una barra de dominadas con soporte, entrenando en su casa", width: 738, height: 946 },
  // Autorización de la persona que aparece: WhatsApp del 2026-11-01 («Si bro» / «Dale no más», en respuesta a «Me avisas si te parece bien si puedo usar esa»). El mural y el logo del gimnasio del fondo están difuminados (marca de terceros).
  { src: "/plan-online/dominada-lastre.webp", alt: "Estudiante del plan online colgado de una barra de dominadas en un rack, con un disco de peso colgado de un cinturón con cadena", width: 738, height: 905 },
];

/** Fotos que sí se pueden mostrar: con archivo y descripción. */
export function fotosPlanOnlineVisibles(lista: FotoPlanOnline[] = FOTOS_PLAN_ONLINE): FotoPlanOnline[] {
  return lista.filter((f) => f.src.trim() !== "" && f.alt.trim() !== "");
}
